import { MapLayer } from './map-layer';

export class MapServer {
  id: string;
  name: string;
  endpointUrl: string;
  layers: Partial<MapLayer>[];
}
